export default "__VITE_ASSET__B3JDdC5m__"